module.exports = __webpack_public_path__ + "static/img/AnxunLogo.ca1a61b9.png";